var endpointMap = {
	am: {
		"pages.homepage": "translation-am.json",
		"pages.nav": "translation-am.json"
	},
	"am-ET": {
		"pages.homepage": "translation-am.json",
		"pages.nav": "translation-am.json"
	},
	ar: {
		"pages.homepage": "translation-ar.json",
		"pages.nav": "translation-ar.json"
	},
	"ar-SA": {
		"pages.homepage": "translation-ar.json",
		"pages.nav": "translation-ar.json"
	},
	bn: {
		"pages.homepage": "translation-bn.json",
		"pages.nav": "translation-bn.json"
	},
	"bn-IN": {
		"pages.homepage": "translation-bn.json",
		"pages.nav": "translation-bn.json"
	},
	cs: {
		"pages.homepage": "translation-cs.json",
		"pages.nav": "translation-cs.json"
	},
	"cs-CZ": {
		"pages.homepage": "translation-cs.json",
		"pages.nav": "translation-cs.json"
	},
	de: {
		"pages.homepage": "translation-de.json",
		"pages.nav": "translation-de.json"
	},
	"de-DE": {
		"pages.homepage": "translation-de.json",
		"pages.nav": "translation-de.json"
	},
	en: {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json"
	},
	"en-CA": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json"
	},
	"en-GB": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json"
	},
	"en-IN": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json"
	},
	"en-US": {
		"pages.homepage": "translation-en.json",
		"pages.nav": "translation-en.json"
	},
	es: {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json"
	},
	"es-ES": {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json"
	},
	"es-MX": {
		"pages.homepage": "translation-es.json",
		"pages.nav": "translation-es.json"
	},
	fa: {
		"pages.homepage": "translation-fa.json",
		"pages.nav": "translation-fa.json"
	},
	"fa-AF": {
		"pages.homepage": "translation-fa.json",
		"pages.nav": "translation-fa.json"
	},
	fil: {
		"pages.homepage": "translation-fil.json",
		"pages.nav": "translation-fil.json"
	},
	fr: {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json"
	},
	"fr-CA": {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json"
	},
	"fr-FR": {
		"pages.homepage": "translation-fr.json",
		"pages.nav": "translation-fr.json"
	},
	gu: {
		"pages.homepage": "translation-gu.json",
		"pages.nav": "translation-gu.json"
	},
	"gu-IN": {
		"pages.homepage": "translation-gu.json",
		"pages.nav": "translation-gu.json"
	},
	hi: {
		"pages.homepage": "translation-hi.json",
		"pages.nav": "translation-hi.json"
	},
	"hi-IN": {
		"pages.homepage": "translation-hi.json",
		"pages.nav": "translation-hi.json"
	},
	ht: {
		"pages.homepage": "translation-ht.json",
		"pages.nav": "translation-ht.json"
	},
	"ht-HT": {
		"pages.homepage": "translation-ht.json",
		"pages.nav": "translation-ht.json"
	},
	id: {
		"pages.homepage": "translation-id.json",
		"pages.nav": "translation-id.json"
	},
	"id-ID": {
		"pages.homepage": "translation-id.json",
		"pages.nav": "translation-id.json"
	},
	it: {
		"pages.homepage": "translation-it.json",
		"pages.nav": "translation-it.json"
	},
	"it-IT": {
		"pages.homepage": "translation-it.json",
		"pages.nav": "translation-it.json"
	},
	ja: {
		"pages.homepage": "translation-ja.json",
		"pages.nav": "translation-ja.json"
	},
	"ja-JP": {
		"pages.homepage": "translation-ja.json",
		"pages.nav": "translation-ja.json"
	},
	ko: {
		"pages.homepage": "translation-ko.json",
		"pages.nav": "translation-ko.json"
	},
	"ko-KR": {
		"pages.homepage": "translation-ko.json",
		"pages.nav": "translation-ko.json"
	},
	ne: {
		"pages.homepage": "translation-ne.json",
		"pages.nav": "translation-ne.json"
	},
	"ne-NP": {
		"pages.homepage": "translation-ne.json",
		"pages.nav": "translation-ne.json"
	},
	nl: {
		"pages.homepage": "translation-nl.json",
		"pages.nav": "translation-nl.json"
	},
	"nl-NL": {
		"pages.homepage": "translation-nl.json",
		"pages.nav": "translation-nl.json"
	},
	pa: {
		"pages.homepage": "translation-pa.json",
		"pages.nav": "translation-pa.json"
	},
	"pa-IN": {
		"pages.homepage": "translation-pa.json",
		"pages.nav": "translation-pa.json"
	},
	pl: {
		"pages.homepage": "translation-pl.json",
		"pages.nav": "translation-pl.json"
	},
	"pl-PL": {
		"pages.homepage": "translation-pl.json",
		"pages.nav": "translation-pl.json"
	},
	pt: {
		"pages.homepage": "translation-pt.json",
		"pages.nav": "translation-pt.json"
	},
	"pt-BR": {
		"pages.homepage": "translation-pt.json",
		"pages.nav": "translation-pt.json"
	},
	ro: {
		"pages.homepage": "translation-ro.json",
		"pages.nav": "translation-ro.json"
	},
	"ro-RO": {
		"pages.homepage": "translation-ro.json",
		"pages.nav": "translation-ro.json"
	},
	ru: {
		"pages.homepage": "translation-ru.json",
		"pages.nav": "translation-ru.json"
	},
	"ru-RU": {
		"pages.homepage": "translation-ru.json",
		"pages.nav": "translation-ru.json"
	},
	rw: {
		"pages.homepage": "translation-rw.json",
		"pages.nav": "translation-rw.json"
	},
	"rw-RW": {
		"pages.homepage": "translation-rw.json",
		"pages.nav": "translation-rw.json"
	},
	sk: {
		"pages.homepage": "translation-sk.json",
		"pages.nav": "translation-sk.json"
	},
	"sk-SK": {
		"pages.homepage": "translation-sk.json",
		"pages.nav": "translation-sk.json"
	},
	so: {
		"pages.homepage": "translation-so.json",
		"pages.nav": "translation-so.json"
	},
	"so-SO": {
		"pages.homepage": "translation-so.json",
		"pages.nav": "translation-so.json"
	},
	sw: {
		"pages.homepage": "translation-sw.json",
		"pages.nav": "translation-sw.json"
	},
	"sw-KE": {
		"pages.homepage": "translation-sw.json",
		"pages.nav": "translation-sw.json"
	},
	ta: {
		"pages.homepage": "translation-ta.json",
		"pages.nav": "translation-ta.json"
	},
	"ta-IN": {
		"pages.homepage": "translation-ta.json",
		"pages.nav": "translation-ta.json"
	},
	te: {
		"pages.homepage": "translation-te.json",
		"pages.nav": "translation-te.json"
	},
	"te-IN": {
		"pages.homepage": "translation-te.json",
		"pages.nav": "translation-te.json"
	},
	ti: {
		"pages.homepage": "translation-ti.json",
		"pages.nav": "translation-ti.json"
	},
	"ti-ER": {
		"pages.homepage": "translation-ti.json",
		"pages.nav": "translation-ti.json"
	},
	"tl-PH": {
		"pages.homepage": "translation-fil.json",
		"pages.nav": "translation-fil.json"
	},
	tr: {
		"pages.homepage": "translation-tr.json",
		"pages.nav": "translation-tr.json"
	},
	"tr-TR": {
		"pages.homepage": "translation-tr.json",
		"pages.nav": "translation-tr.json"
	},
	uk: {
		"pages.homepage": "translation-uk.json",
		"pages.nav": "translation-uk.json"
	},
	"uk-UA": {
		"pages.homepage": "translation-uk.json",
		"pages.nav": "translation-uk.json"
	},
	und: {
		"pages.homepage": "translation.json",
		"pages.nav": "translation.json"
	},
	ur: {
		"pages.homepage": "translation-ur.json",
		"pages.nav": "translation-ur.json"
	},
	"ur-PK": {
		"pages.homepage": "translation-ur.json",
		"pages.nav": "translation-ur.json"
	},
	vi: {
		"pages.homepage": "translation-vi.json",
		"pages.nav": "translation-vi.json"
	},
	"vi-VN": {
		"pages.homepage": "translation-vi.json",
		"pages.nav": "translation-vi.json"
	},
	zh: {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json"
	},
	"zh-CN": {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json"
	},
	"zh-TW": {
		"pages.homepage": "translation-zh.json",
		"pages.nav": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
